import { eachDayOfInterval, endOfWeek, format, startOfWeek } from "date-fns";
import { useEffect, useRef } from "react";

class Util {
  constructor(locale = "es-MX", currencyValue = "MXN") {
    this.numberFormater = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyValue,
    }); //new Intl.NumberFormat(locale);
    // new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' })
  }
  static numberFormater() {
    return this.numberFormatter;
  }
}

//'es-MX', { style: 'currency', currency: 'MXN' })

export var Singleton = (function () {
  var instance, instance2;

  function createInstance() {
    const locale = "es-MX";
    const currencyValue = "MXN";
    var object = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyValue,
    });
    return object;
  }

  function createInstance2() {
    const locale = "es-MX";
    const currencyValue = "MXN";
    var object = new Intl.NumberFormat(locale, {
      //  currency: currencyValue,
      minimumFractionDigits: 2,
    });
    return object;
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
    getInstance2: function () {
      if (!instance2) {
        instance2 = createInstance2();
      }
      return instance2;
    },
  };
})();

export var ImagePathBuilder = (function () {
  var instance;

  function createInstance() {
    const baseURL =
      window.env?.VARS_BACKEND_URL ?? process.env.REACT_APP_SERVER_DOMAIN;
    const baseUrl = new URL("/", baseURL);
    const final = new URL("/Resources/", baseUrl);
    return final;
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
    to: function (imageURL) {
      const final = new URL(imageURL, this.getInstance());
      return final;
    },
  };
})();

export function useTraceUpdate(props, log = "") {
  const prev = useRef(props);
  useEffect(() => {
    const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
      if (prev.current[k] !== v) {
        ps[k] = [prev.current[k], v];
      }
      return ps;
    }, {});
    if (Object.keys(changedProps).length > 0) {
      console.log("Changed props: ", changedProps);
      console.log("Changed in: ", log);
    }
    prev.current = props;
  });
}

export var range = (start, stop, step = 1) => {
  const length = Math.ceil((stop - start) / step);
  return Array.from({ length }, (_, i) => i * step + start);
};

export function buildName(item, includeMaterno = false) {
  if (item == null) return "";
  const items = [item.nombre ?? "", item.apellidoPaterno ?? ""];
  if (includeMaterno) {
    items.push(item.apellidoMaterno ?? "");
  }

  const itemsClean = items.map((item) => item.trim());

  return itemsClean.join(" ");
}

///TODO
export function buildNameWithId(item, id, includeMaterno = false) {
  if (item == null) return "";

  const nombres = buildName(item, includeMaterno);
  if (id == null) {
    return `${nombres}`;
  }
  return `${id} - ${nombres}`;
}

export function buildProductNameWithId(item) {
  let num = item.numProducto ?? "";
  let nombre = item.nombre ?? "";

  return `${num} - ${nombre}`;
}

export function capitalizeText(word) {
  if (word.length === 0) return "";

  return word.charAt(0).toUpperCase() + word.slice(1);
}

export const getMonthNames = (locale, allMonths = true, year = undefined) => {
  let startingMonthIndex = 0;
  const today = new Date();
  if (year == null) {
    year = today.getFullYear();
  }
  if (!allMonths && year === today.getFullYear()) {
    startingMonthIndex = today.getMonth();
  }

  const MaxMonthIndex = 12;
  const monthNames = [];
  for (let i = startingMonthIndex; i < MaxMonthIndex; i++) {
    // Create a date object for the first day of each month
    // The year (2000) is arbitrary as it doesn't affect the month name
    const date = new Date(year, i, 1);
    const name = format(date, "MMMM", { locale });
    monthNames.push(capitalizeText(name));
  }
  return monthNames;
};

export const getYearsUntilNow = (locale, sinceYear = undefined) => {
  const today = new Date();
  let sinceYearA = sinceYear;
  if (sinceYearA == null) {
    sinceYearA = 2025;
  }

  const MaxYear = today.getFullYear();
  const years = [];
  for (let i = sinceYearA; i <= MaxYear; i++) {
    const date = new Date(i, 1, 1);
    years.push(date.getFullYear());
  }
  return years;
};

export function getMonthDiff(startDate, endDate) {
  const MonthsInYear = 12;
  return (
    (endDate.getFullYear() - startDate.getFullYear()) * MonthsInYear +
    endDate.getMonth() -
    startDate.getMonth()
  );
}
/*
// Example usage:
const date1 = new Date('2025-01-15');
const date2 = new Date('2026-03-20');

console.log(getMonthDiff(date1, date2)); // Output: 14
*/

export function roundToNearest(num, multipleOf) {
  //return Math.round(num / 10) * 10;
  return Math.round(num / multipleOf) * multipleOf;
}

export function truncateToTwoDecimals(num) {
  return Math.floor(num * 100) / 100;
}

export function onlyNumbers(value) {
  if (typeof value !== "string") return value;
  const valueRaw = value
    .replace(/^0*(\d)/, "$1")
    .replace(/\.\d+$/, "")
    .replace(/[^0-9]/g, "");
  return valueRaw;
}

export function onlyNumbersFloat(value) {
  if (typeof value !== "string") return value;
  const valueRaw = value.replace(/^0*(\d)/, "$1").replace(/[^0-9.]/g, "");
  return valueRaw;
}

//https://github.com/date-fns/date-fns/issues/644
export const getWeekDays = (locale) => {
  const now = new Date();
  const weekDays = [];
  const start = startOfWeek(now, { locale, weekStartsOn: 0 });
  const end = endOfWeek(now, { locale });
  eachDayOfInterval({ start, end }).forEach((day) => {
    weekDays.push(format(day, "EEEEEE", { locale }).toUpperCase());
  });
  return weekDays;
};

export const getMonthNames2 = (locale) => {
  const monthNames = [];
  const MonthsCount = 12;
  for (let index = 0; index < MonthsCount; index++) {
    const shortMonthName = locale.localize.month(index, {
      width: "abbreviated",
    });
    monthNames.push(shortMonthName);
  }

  return monthNames;
};

export function deepEqual(obj1, obj2) {
  if (obj1 == null && obj2 == null) return true;

  if ((obj1 == null || obj2 == null) && obj1 !== obj2) return true;

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    if (!obj2.hasOwnProperty(key)) {
      return false;
    }
    if (typeof obj1[key] === "object" && typeof obj2[key] === "object") {
      if (!deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    } else {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }
  }
  return true;
}

export function formatCurrencyOnly(data) {
  return typeof data === "string" ? data : Singleton.getInstance().format(data);
}
